/**
 * Kebab-cases (dash-cases) the given string.
 *
 * @param {string} str
 * @returns {string}
 */
export default function kebabCase(str) {
    // Lower cases the string
    let _str = str;
    if (!/[a-zæøåàáäâëêéèïîíìöòóôüúùû]/.test(_str)) _str = str.toLowerCase();
    return _str
        .replace(/(?:_)[A-ZÅÀÁÂÄÆËÊÉÈÏÎÍÌÖÔÒÓØÜÛÚÙ]{2,}|[A-Z]{2,}(?=_)/g, $1 => ` ${$1.toLowerCase()}`)
        .replace(/[-_+]/g, ' ')
        .replace(/[ \t\r]*[A-ZÅÀÁÂÄÆËÊÉÈÏÎÍÌÖÔÒÓØÜÛÚÙ]+[ \t\r]+/g, $1 => ` ${$1.toLowerCase()} `)
        .replace(/[A-ZÅÀÁÂÄÆËÊÉÈÏÎÍÌÖÔÒÓØÜÛÚÙ]/g, $1 => ` ${$1.toLowerCase()}`)
        .replace(/^[ \t\r]+/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+/g, '-');
}
